const { getProducts, navigationTargets } = require('./site-navigation.cjs')

const content = {
  ZH: {
    products: '产品',
    industries: [
      ['医疗健康', []],
      ['健身运动', [['健身房', ['健身房']], ['瑜伽馆', ['瑜伽馆']], ['普拉提馆', ['普拉提馆']]]],
      ['专业运动', [['体适能机构', ['体适能机构']], ['青训队', ['青训队']], ['体育俱乐部', ['体育俱乐部']]]]
    ],
    support: '服务与支持', services: ['管理平台', '设备支持', '常见问题'],
    about: '关于 ANOVATOR', company: ['企业简介', '企业文化', '发展历程', '资质认证', '新闻资讯']
  },
  EN: {
    products: 'Products',
    industries: [
      ['Healthcare', [['Experience Centers', ['Experience Center']], ['Weight Management Centers', ['Weight Management']], ['Rehabilitation Medicine', ['Rehabilitation Medicine']], ['Clinical Nutrition', ['Clinical Nutrition']], ['Orthopedics', ['Orthopedics']], ['Cardiology', ['Cardiology']], ['Pediatrics', ['Pediatrics']]]],
      ['Fitness & Sports', [['Gyms', ['Gyms']], ['Yoga Studios', ['Yoga Studios']], ['Pilates Studios', ['Pilates Studios']]]],
      ['Professional Sports', [['Physical Fitness Institutions', ['Physical Fitness Institutions']], ['Youth Training Academies', ['Youth Training Academies']], ['Sports Clubs', ['Sports Clubs']]]]
    ],
    support: 'Services & Support', services: ['Administrator Platform', 'Device Support', 'FAQ'],
    about: 'About ANOVATOR', company: ['Company Profile', 'Corporate Culture', 'Company History', 'Qualification', 'Newsroom']
  }
}

function findHealthcareTopic(category, label, terms) {
  const normalize = value => String(value).trim().replace(/\s+/g, ' ').toLowerCase().replace(/专项解决方案$/, '')
  const names = [label, ...terms].map(normalize)
  const matches = category?.items.filter(topic => names.includes(normalize(topic.label))) || []
  // Missing or ambiguous topics stay text; never borrow a similarly named detail.
  return matches.length === 1 ? matches[0] : null
}

function getFooterNavigation(language, industryMenu = []) {
  const copy = content[language] || content.EN
  const companyPaths = ['#company-profile', '#corporate-culture', '#company-history', '#qualification']
    .map(hash => `${navigationTargets.about}${hash}`).concat(navigationTargets.news)
  const groups = [
    { id: 'products', label: copy.products, items: getProducts(language).map(product => ({ label: product.name, to: product.path })) },
    ...copy.industries.map(([label, items], index) => {
      const category = industryMenu.find(c => c.position === index + 1)
      if (language === 'ZH' && index === 0) {
        return {
          id: 'industry-1', label: category?.label || label,
          ...(category?.path ? { to: category.path } : {}),
          items: (category?.items || []).map(topic => ({ label: topic.label, ...(topic.path ? { to: topic.path } : {}) }))
        }
      }
      return { id: `industry-${index + 1}`, label, ...(category ? { to: category.path } : {}), items: items.map(([label, terms]) => {
        const topic = index === 0
          ? findHealthcareTopic(category, label, terms)
          : category?.items.find(t => terms.some(term => String(t.label).toLowerCase().includes(term.toLowerCase())))
        return { label, ...(topic ? { to: topic.path } : {}) }
      }) }
    }),
    { id: 'support', label: copy.support, to: navigationTargets.support, items: [
      { label: copy.services[0], href: navigationTargets.administratorPlatform },
      { label: copy.services[1], action: 'contact' },
      { label: copy.services[2], to: navigationTargets.faq }
    ] },
    { id: 'about', label: copy.about, to: navigationTargets.about, items: copy.company.map((label, index) => ({ label, to: companyPaths[index] })) }
  ]
  return groups
}

module.exports = { getFooterNavigation }
